import { IconSuperCoach } from '@leland-dev/leland-ui-library';
import { type FC } from 'react';

interface SuperCoachTagProps {
  isLarge?: boolean;
}

export const SuperCoachTag: FC<SuperCoachTagProps> = ({ isLarge = false }) => (
  <div
    className={`inline-flex items-center justify-center space-x-2 rounded-full border border-[#1142a033] bg-white bg-cover bg-no-repeat ${isLarge ? 'px-3 py-1.5' : 'px-2.5 py-1.5'} text-sm font-medium text-[#1142A0]`}
    style={{
      background: `
        radial-gradient(circle at 20% 20%, #75c7f5 0%, transparent 40%),
        radial-gradient(circle at 80% 40%, #ffffff 0%, transparent 60%),
        radial-gradient(circle at 90% 85%, #d9bff2 0%, transparent 50%),
        radial-gradient(circle at 70% 70%, #f2fbff 0%, transparent 70%)
      `,
    }}
  >
    <IconSuperCoach className={`${isLarge ? 'size-4' : 'size-3.5'}`} />
    <p
      className={`${isLarge ? 'text-base font-medium' : ''} sm:whitespace-nowrap`}
    >
      Super Coach
    </p>
  </div>
);
